<template>
  <div class="r_page">
    <el-pagination
      class="pagination"
      @size-change="onSizeChange"
      @current-change="onCurrentChange"
      :current-page.sync="currentPage"
      :page-sizes="defaultPageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
export default {
  data () {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      defaultPageSizes: [10, 100, 200, 500]
    }
  },
  // props: ['pageSize'],
  methods: {
    getSize () {
      return this.pageSize
    },
    reset (total) {
      this.total = total
      this.currentPage = 1
    },
    setTotal (total) {
      this.total = total
    },
    setCurPage (curPage) {
      this.currentPage = curPage
    },
    onSizeChange (pageSize) {
      this.pageSize = pageSize
      this.$emit('change', pageSize, this.currentPage)
    },
    onCurrentChange (currentPage) {
      this.$emit('change', this.pageSize, currentPage)
    }
  }
}
</script>

<style scoped>
  .pagination {
    margin-top: 10px;
    float: left;
  }
  .r_page {
    overflow: auto;
  }
</style>
